import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from "react";
import { TableDataCard } from "../TableDataCards";
import { RaiseColors } from "componentLibrary";
import useWindowSize from "hooks/useWindowSize";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NestedTableCards = function NestedTableCards(_ref) {
  var _useWindowSize$innerW;
  var dataList = _ref.dataList,
    headers = _ref.headers,
    renderTitle = _ref.renderTitle,
    onCardClick = _ref.onCardClick;
  var windowSize = (_useWindowSize$innerW = useWindowSize().innerWidth) !== null && _useWindowSize$innerW !== void 0 ? _useWindowSize$innerW : 0;
  headers = _filterInstanceProperty(headers).call(headers, function (h) {
    if (h.isVisible && !h.isVisible(windowSize)) {
      return false;
    }
    return true;
  });
  return /*#__PURE__*/_jsx("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 16
    },
    children: _mapInstanceProperty(dataList).call(dataList, function (item, index) {
      return /*#__PURE__*/_jsxs("div", {
        style: {
          border: "1px solid ".concat(RaiseColors.neutral300),
          borderRadius: "16px",
          gap: 8
        },
        onClick: function onClick(event) {
          onCardClick === null || onCardClick === void 0 || onCardClick(item, index);
          event.stopPropagation();
        },
        children: [renderTitle && /*#__PURE__*/_jsx("div", {
          style: {
            padding: 16,
            borderRadius: "16px 16px 0px 0px",
            borderBottom: "1px solid ".concat(RaiseColors.neutral300),
            backgroundColor: RaiseColors.neutral200
          },
          children: renderTitle === null || renderTitle === void 0 ? void 0 : renderTitle({
            item: item
          })
        }), /*#__PURE__*/_jsx("div", {
          style: {
            padding: 16
          },
          children: /*#__PURE__*/_jsx(TableDataCard, {
            item: item,
            headers: headers,
            isMobile: true,
            rowIndex: index
          })
        })]
      }, index);
    })
  });
};
export default NestedTableCards;